import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { useStateValue } from '@State'
import { history } from './App'
import { LoadingSpinner } from '@CommonComponents'

export const EditAchievement = ({ match }) => {
  const [currentState, dispatch] = useStateValue()
  const [newTemplate, setNewTemplate] = useState({
    id: '',
    name: '',
    designId: '',
  })
  const [requiredScores, setRequiredScores] = useState([])
  const [currAcmt, setCurrAcmt] = useState({})
  const [newAsmtGuid, setNewAsmtGuid] = useState('')
  const [newScore, setNewScore] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  let acmtType = match.params.acmtType
  let coursenum = match.params.coursenum
  let itemId = match.params.itemId

  useEffect(() => {
    const fetchAcmt = async () => {
      let resp = await client.get(
        `/instructor/achievements.get_achievements/${coursenum}/${itemId}/?type=${acmtType}`
      )
      let acmt = resp.data.achievements[0]
      setCurrAcmt(acmt)
      setNewTemplate(acmt.template)
      setRequiredScores(acmt.requiredScores)
    }
    if (match.params.itemId !== '-') {
      fetchAcmt()
    }
  }, [match.params.itemId])

  const handleSave = async evt => {
    evt.preventDefault()
    setIsLoading(true)
    let itemId = match.params.itemId === '-' ? null : match.params.itemId
    let url = !itemId
      ? '/instructor/achievements.create_achievement/'
      : '/instructor/achievements.update_achievement/'

    let postData = {
      itemId: itemId,
      coursenum: currentState.coursenum,
      type: acmtType,
      templateId: newTemplate.id,
      requiredScores: requiredScores,
    }
    let designKey = `${acmtType}DesignId`
    postData[designKey] = newTemplate.designId
    if (currAcmt) {
      postData['certifierId'] = currAcmt.certifierId
    }
    try {
      let resp = await client.post(url, postData)
      let stateAcmts =
        acmtType === 'certificate'
          ? currentState.certificates
          : currentState.badges
      let dispatchType =
        acmtType === 'certificate' ? 'updateCerts' : 'updateBadges'
      let newAcmts
      // if there's not an item id in the params, it's a new
      // achievement so tack it on the end
      if (!itemId) {
        stateAcmts.push(resp.data.achievement)
        newAcmts = stateAcmts
      } else {
        // update the selected achievement in-place
        newAcmts = []
        stateAcmts.map(acmt => {
          if (acmt.id === resp.data.achievement.id) {
            newAcmts.push(resp.data.achievement)
          } else {
            newAcmts.push(acmt)
          }
        })
      }
      dispatch({
        type: dispatchType,
        payload: newAcmts,
      })
      setCurrAcmt(resp.data.achievement)
      history.push(`/instructor/achievements/${coursenum}/`)
    } catch (err) {
      let errMsg = err.response.data.msg
      toast.error(errMsg)
    }
    setIsLoading(false)
  }

  const handleDiscard = () => {
    setNewTemplate({ id: '', name: '', designId: '' })
    setRequiredScores(currAcmt.requiredScores)
    setCurrAcmt(null)
    setNewAsmtGuid('')
    setNewScore('')

    history.push(`/instructor/achievements/${coursenum}/`)
  }

  const handleAddRequirement = e => {
    e.preventDefault()
    let asmtName = currentState.acts.find(act => act[0] === newAsmtGuid)[1]
    let newReq = {
      actGuid: newAsmtGuid,
      score: newScore,
      name: asmtName,
    }
    let newReqScores = [...requiredScores]
    newReqScores.push(newReq)
    setRequiredScores(newReqScores)
    setNewAsmtGuid('')
    setNewScore('')
  }

  const handleRemoveRequirement = (e, guid) => {
    e.preventDefault()
    let newReqs = requiredScores.filter(actScore => actScore.actGuid !== guid)
    setRequiredScores(newReqs)
  }

  const handleTemplateChange = templateId => {
    if (!templateId) {
      setNewTemplate({
        id: '',
        name: '',
        designId: '',
      })
      return
    }
    let template = currentState[`${acmtType}Templates`].filter(
      template => templateId === template.id
    )[0]
    setNewTemplate(template)
  }

  const getFilteredAsmts = () => {
    let chosenGuids = []
    requiredScores.map(asmt => {
      chosenGuids.push(asmt.actGuid)
    })
    let availableAsmts = currentState.acts.filter(
      asmt => !chosenGuids.includes(asmt[0])
    )
    return availableAsmts
  }

  const validateRequirement = () => {
    if (!newAsmtGuid) {
      return false
    }
    if (!newScore) {
      return false
    }
    if (newScore < 1 || newScore > 100) {
      return false
    }
    return true
  }

  return (
    <div className="card-myed w-50">
      <div className="d-flex justify-content-between">
        <h3 className="w-50 mt-0">
          {itemId ? 'Edit' : 'Create'} {acmtType}
        </h3>
        <div className="w-50">
          <div className="d-flex justify-content-end">
            {isLoading && (
              <span className="mt-3">
                <LoadingSpinner className="mt-3" style={{ fontSize: '20px' }} />
              </span>
            )}
            <button
              onClick={handleDiscard}
              className="mx-3 btn btn-myed btn-default btn-default-myed btn-sm-myed"
              disabled={isLoading}
            >
              <i className="fa-regular fa-times mr-2" />
              Discard Changes
            </button>
            <button
              onClick={e => handleSave(e)}
              className="m-0 btn btn-myed btn-default btn-default-myed btn-sm-myed"
              disabled={!newTemplate.id}
            >
              <i className="fa-regular fa-check mr-2" />
              Save Changes
            </button>
          </div>
        </div>
      </div>
      <Form>
        <Form.Group className="mr-4">
          <Form.Label className="mb-0">Template</Form.Label>
          <Form.Control
            as="select"
            value={newTemplate.id}
            onChange={e => handleTemplateChange(e.target.value)}
          >
            <option value="">Select Template</option>
            {currentState[`${acmtType}Templates`].map((template, i) => (
              <option key={i} value={template.id}>
                {`${template.name} - ${template.designId}`}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <h6>Name: {newTemplate.name}</h6>
        <h6>Design ID: {newTemplate.designId}</h6>
        <div>
          <span
            style={{ fontSize: '14px', fontFamily: 'var(--font-ui)' }}
          >
            Required Assessments
          </span>
        </div>
        {requiredScores.length > 0 ? (
          <table className="w-50 table table-bordered">
            <thead>
              <tr>
                <th className="w-50" scope="col">
                  Assessment Name
                </th>
                <th className="w-50" scope="col">
                  Minimum Score
                </th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {requiredScores.map((actScore, i) => (
                <tr key={i}>
                  <td>{actScore.name}</td>
                  <td>{actScore.score}%</td>
                  <td>
                    <button
                      className="p-0 btn btn-sm btn-link text-danger"
                      onClick={e =>
                        handleRemoveRequirement(e, actScore.actGuid)
                      }
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <span>
            <i>
              No requirements set for this {acmtType}. It will not be awarded.
            </i>
          </span>
        )}
        <div className="d-flex mt-4">
          <Form.Group className="mr-4">
            <Form.Label className="mb-0">Assessment Name</Form.Label>
            <Form.Control
              as="select"
              value={newAsmtGuid}
              onChange={e => setNewAsmtGuid(e.target.value)}
            >
              <option value="">Select Assessment</option>
              {getFilteredAsmts().map((act, i) => (
                <option key={i} value={act[0]}>
                  {act[1]}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label className="mb-0">Passing Score (%)</Form.Label>
            <Form.Control
              type="number"
              step=".1"
              min="1"
              max="100"
              onChange={e => setNewScore(e.target.value)}
              value={newScore}
            />
          </Form.Group>
          <button
            className="btn btn-sm btn-link text-primary"
            onClick={handleAddRequirement}
            disabled={!validateRequirement()}
          >
            Add
          </button>
        </div>
      </Form>
    </div>
  )
}
